import React from 'react';
import { string } from 'prop-types';

// Import components
import AuthMethodsButtons from './AuthMethodsButtons';
import PhoneAuthentication from './PhoneAuthentication';

// Import styles
import { MethodsWrapper } from './style';

// Import logic
import { useAuthentication } from './hooks';

const FirebaseAuthentication = ({ sourceName }) => {
	const {
		isPhoneAuthView,
		showPhoneAuthentication,
		authenticationSubmit,
		setIsPhoneAuthView,
		userCountryCode,
		hidePhoneAuthView
	} = useAuthentication();

	return (
		<MethodsWrapper>
			{isPhoneAuthView ? (
				<PhoneAuthentication
					userCountryCode={userCountryCode}
					hidePhoneAuthView={hidePhoneAuthView}
				/>
			) : (
				<AuthMethodsButtons
					authenticationSubmit={authenticationSubmit}
					showPhoneAuth={showPhoneAuthentication}
					setIsPhoneAuthView={setIsPhoneAuthView}
					sourceName={sourceName}
				/>
			)}
		</MethodsWrapper>
	);
};

FirebaseAuthentication.propTypes = {
	sourceName: string
};

export default FirebaseAuthentication;
